export default __webpack_public_path__ + "static/media/success-icon.ae3d962f.svg";